import { inject, injectable } from "inversify";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { ProceedingRepository } from "@proceeding/data/repositories/proceeding.repository";

@injectable()
export class DeleteProceedingUseCase {
    constructor(
        @inject(ProceedingRepository)
        private readonly proceedingRepository: ProceedingRepository,
    ) { }

    async execute(proceedingId: number): Promise<boolean> {
        const result = await this.proceedingRepository.delete(proceedingId);

        if (result.isLeft()) {
            ToastManagerStore.error(result.getLeftOrThrow().message);
            return false;
        }

        return true;
    }
}